module.exports = __webpack_public_path__ + "img/dices_b.b36e69d7.svg";